module.exports = __webpack_public_path__ + "static/media/rollingstone_culture_features_el-chapo-speaks-20160109_plot.db5e0ce2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/rollingstone_culture_features_el-chapo-speaks-20160109_plot.png
// module id = 422
// module chunks = 0